/* CASAS CHINA · casaschina.cl — tema Shopify
   Menú móvil, origen de los QR impresos (?c= tarjeta, ?p= ficha, ?m= modelo), formulario,
   filtros de modelos y obras, panel por capas y galería de producto. */
(function () {
  'use strict';
  var d = document;

  function lower(v) { return (v || '').toString().toLowerCase().trim(); }
  function each(list, fn) { Array.prototype.forEach.call(list, fn); }
  function own(o, k) { return !!o && !!k && Object.prototype.hasOwnProperty.call(o, k); }

  /* ---------- header ---------- */
  function initHeader() {
    var hdr = d.querySelector('.hdr');
    if (hdr && !hdr.dataset.ccInit) {
      hdr.dataset.ccInit = '1';
      var onScroll = function () { hdr.classList.toggle('scrolled', window.scrollY > 8); };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
    var menu = d.querySelector('[data-cc-menu]');
    if (menu && !menu.dataset.ccInit) {
      menu.dataset.ccInit = '1';
      menu.addEventListener('click', function (e) { if (e.target.closest('a')) menu.open = false; });
      d.addEventListener('keydown', function (e) { if (e.key === 'Escape') menu.open = false; });
      d.addEventListener('click', function (e) { if (menu.open && !menu.contains(e.target)) menu.open = false; });
    }
    // the quote buttons point to the form on this page when it exists
    if (d.getElementById('visita')) {
      each(d.querySelectorAll('a[data-cc-cta]'), function (a) { a.setAttribute('href', '#visita'); });
    }
  }

  /* ---------- QR origin + contact form ---------- */
  var QR = null, form = null, src = { c: null, p: null, m: null, mFrom: 'qr' };

  function field(name) { return form ? form.querySelector('[data-cc-f="' + name + '"]') : null; }
  function setProduct(val) {
    var s = form && form.querySelector('[data-cc-product]');
    if (s && val) s.value = val;
  }
  function renderScan() {
    var box = d.querySelector('[data-cc-scan]');
    if (!box || !QR) return;
    var tags = box.querySelector('[data-cc-scan-tags]'), prev = box.querySelector('[data-cc-scan-model]');
    if (!src.c && !src.p && !src.m) { box.hidden = true; return; }
    tags.innerHTML = '';
    var tag = function (html) { var s = d.createElement('span'); s.className = 'tag'; s.innerHTML = html; tags.appendChild(s); };
    if (src.c) tag(QR.c[src.c][0]);
    if (src.p) tag(QR.p[src.p][0]);
    if (src.m) {
      var mm = QR.m[src.m];
      tag(QR.model_label + ': ' + mm[0] + ' · ' + mm[1]);
      if (prev) {
        var img = prev.querySelector('img');
        img.src = QR.img.split('?')[0].replace('m-cc-01.jpg', 'm-' + src.m + '.jpg');
        img.alt = mm[0];
        prev.hidden = false;
      }
    } else if (prev) { prev.hidden = true; }
    box.hidden = false;
  }
  function applySrc() {
    if (!form || !QR) return;
    if (src.c && field('origen')) field('origen').value = QR.c[src.c][1] + ' (c=' + src.c + ')';
    if (src.p) {
      if (field('ficha')) field('ficha').value = QR.p[src.p][1] + ' (p=' + src.p + ')';
      if (src.p === 'ft01' || src.p === 'ft02') {
        var t = form.querySelector('[data-cc-tech]');
        if (t) t.checked = true;
        setProduct('Panel de muro');
      }
      if (src.p === 'cat26') setProduct('Casas industrializadas');
    }
    if (src.m) {
      var mm = QR.m[src.m];
      if (field('modelo')) field('modelo').value = mm[0] + ' · ' + mm[2] + (src.mFrom === 'qr' ? ' (QR del catálogo de modelos)' : ' (sección Modelos de la web)');
      setProduct('Casas industrializadas');
    }
    renderScan();
  }
  function goForm() {
    var v = d.getElementById('visita');
    if (v) v.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
  function initForm() {
    var qrEl = d.querySelector('script[data-cc-qr]');
    try { QR = qrEl ? JSON.parse(qrEl.textContent) : null; } catch (e) { QR = null; }
    form = d.getElementById('cc-contact');
    if (!form) return;

    if (QR) {
      var qs = null;
      try { qs = new URLSearchParams(location.search); } catch (e) {}
      var c = qs ? lower(qs.get('c')) : '', p = qs ? lower(qs.get('p')) : '', m = qs ? lower(qs.get('m')) : '';
      var hm = /^#([cpm])-([a-z0-9-]+)$/.exec(lower(location.hash));
      if (hm) {
        if (hm[1] === 'c' && !c) c = hm[2];
        if (hm[1] === 'p' && !p) p = hm[2];
        if (hm[1] === 'm' && !m) m = hm[2];
      }
      if (own(QR.c, c)) src.c = c;
      if (own(QR.p, p)) src.p = p;
      if (own(QR.m, m)) src.m = m;
      applySrc();
    }

    var posted = d.querySelector('[data-cc-posted]');
    if (posted) {
      window.addEventListener('load', function () {
        setTimeout(function () { posted.scrollIntoView({ block: 'center' }); try { posted.focus({ preventScroll: true }); } catch (e) {} }, 200);
      });
    } else if (src.c || src.p || src.m) {
      window.addEventListener('load', function () { setTimeout(goForm, 250); });
    }

    if (!form.dataset.ccInit) {
      form.dataset.ccInit = '1';
      form.setAttribute('novalidate', '');
      var err = form.querySelector('[data-cc-err]');
      form.addEventListener('submit', function (ev) {
        var ok = true;
        each(form.querySelectorAll('[required]'), function (el) {
          var v = (el.value || '').trim();
          var bad = el.type === 'checkbox' ? !el.checked : (!v || (el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v)));
          var box = el.closest('.fld') || el.closest('.check');
          if (box) box.classList.toggle('bad', bad);
          if (bad) ok = false;
        });
        if (!ok) {
          ev.preventDefault();
          if (err) err.hidden = false;
          var first = form.querySelector('.bad input, .bad select, .bad textarea');
          if (first) first.focus();
          return;
        }
        if (err) err.hidden = true;
        // empty optional fields are not sent, so the notification e-mail only lists what the visitor filled in
        each(form.querySelectorAll('[name^="contact["]'), function (el) {
          if (el.required || el.type === 'checkbox' || el.name === 'contact[body]') return;
          if (!(el.value || '').trim()) { el.setAttribute('data-cc-name', el.name); el.removeAttribute('name'); }
        });
        var btn = form.querySelector('button[type="submit"]');
        if (btn && btn.dataset.sending) {
          var l = btn.querySelector('span');
          if (l) l.textContent = btn.dataset.sending;
        }
      });
    }
  }

  // "Solicita información" on a model card: mark the model in the form of this page
  d.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a.mq');
    if (!a || !form || !QR) return;
    var slug = a.getAttribute('data-slug');
    if (!own(QR.m, slug)) return;
    e.preventDefault();
    src.m = slug; src.mFrom = 'web';
    applySrc();
    goForm();
  });

  // back/forward cache: give the fields their names back
  window.addEventListener('pageshow', function () {
    each(d.querySelectorAll('[data-cc-name]'), function (el) { el.setAttribute('name', el.getAttribute('data-cc-name')); el.removeAttribute('data-cc-name'); });
  });

  /* ---------- copy e-mail ---------- */
  function initCopy(root) {
    each(root.querySelectorAll('[data-cc-copy]'), function (b) {
      if (b.dataset.ccInit) return;
      b.dataset.ccInit = '1';
      b.addEventListener('click', function () {
        var txt = b.getAttribute('data-cc-copy'), o = b.innerHTML;
        var done = function () { b.innerHTML = b.getAttribute('data-done') || '✓'; setTimeout(function () { b.innerHTML = o; }, 1800); };
        try { navigator.clipboard.writeText(txt).then(done, function () {}); } catch (e) {}
      });
    });
  }

  /* ---------- models: filter + show more ---------- */
  function initModels(root) {
    each(root.querySelectorAll('[data-cc-models]'), function (grid) {
      if (grid.dataset.ccInit) return;
      grid.dataset.ccInit = '1';
      var sec = grid.closest('section') || root;
      var chips = sec.querySelectorAll('[data-cc-chips] button');
      var more = sec.querySelector('[data-cc-more]');
      var cards = Array.prototype.slice.call(grid.querySelectorAll('.mcard'));
      var size = parseInt(grid.getAttribute('data-page'), 10) || 9;
      var cat = grid.getAttribute('data-start') || 'all', shown = size;
      var render = function () {
        var n = 0;
        cards.forEach(function (c) {
          var ok = cat === 'all' || c.getAttribute('data-cat') === cat;
          if (ok) { n++; c.hidden = n > shown; } else { c.hidden = true; }
        });
        if (more) more.hidden = n <= shown;
      };
      each(chips, function (b) {
        b.addEventListener('click', function () {
          each(chips, function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
          cat = b.getAttribute('data-mf'); shown = size; render();
        });
      });
      if (more) more.addEventListener('click', function () { shown += size; render(); });
      render();
    });
  }

  /* ---------- reference projects filter ---------- */
  function initGallery(root) {
    each(root.querySelectorAll('[data-cc-gal]'), function (gal) {
      if (gal.dataset.ccInit) return;
      gal.dataset.ccInit = '1';
      var sec = gal.closest('section') || root;
      var chips = sec.querySelectorAll('[data-cc-gchips] button'), figs = gal.querySelectorAll('figure');
      each(chips, function (c) {
        c.addEventListener('click', function () {
          each(chips, function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
          var f = c.getAttribute('data-f');
          each(figs, function (fig) { fig.hidden = !(f === 'all' || fig.getAttribute('data-cat').split(' ').indexOf(f) >= 0); });
        });
      });
    });
  }

  /* ---------- panel layer by layer ---------- */
  function initPanel(root) {
    each(root.querySelectorAll('[data-cc-panel]'), function (fig) {
      if (fig.dataset.ccInit) return;
      fig.dataset.ccInit = '1';
      var svg = fig.querySelector('svg'), rng = fig.querySelector('[data-cc-explode]');
      if (!svg) return;
      var vx = parseFloat(svg.getAttribute('data-vx')), vy = parseFloat(svg.getAttribute('data-vy'));
      var layers = svg.querySelectorAll('.lyr');
      var explode = function (e) {
        each(layers, function (g) {
          var f = parseFloat(g.getAttribute('data-f'));
          g.setAttribute('transform', 'translate(' + (e * f * vx).toFixed(2) + ' ' + (e * f * vy).toFixed(2) + ')');
        });
      };
      if (rng) rng.addEventListener('input', function () { explode(rng.value / 100); });
      var sec = fig.closest('section') || root;
      each(sec.querySelectorAll('.legend li'), function (li) {
        var on = function () { svg.classList.add('focus'); each(layers, function (g) { g.classList.toggle('on', g.getAttribute('data-layer') === li.getAttribute('data-layer')); }); };
        var off = function () { svg.classList.remove('focus'); };
        li.addEventListener('mouseenter', on); li.addEventListener('mouseleave', off);
        li.addEventListener('focus', on); li.addEventListener('blur', off);
      });
    });
  }

  /* ---------- product gallery ---------- */
  function initProductGallery(root) {
    each(root.querySelectorAll('[data-cc-gallery]'), function (g) {
      if (g.dataset.ccInit) return;
      g.dataset.ccInit = '1';
      var main = g.querySelector('.pgal-main img');
      var btns = g.querySelectorAll('.pgal-th button');
      each(btns, function (b) {
        b.addEventListener('click', function () {
          if (main) { main.removeAttribute('srcset'); main.src = b.getAttribute('data-src'); }
          each(btns, function (x) { x.setAttribute('aria-current', x === b ? 'true' : 'false'); });
        });
      });
    });
  }

  function initAll(root) {
    initCopy(root); initModels(root); initGallery(root); initPanel(root); initProductGallery(root);
  }

  function boot() { initHeader(); initForm(); initAll(d); }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', boot); else boot();

  // theme editor: re-run when a section is added or changed
  d.addEventListener('shopify:section:load', function (e) {
    initHeader();
    if (e.target && e.target.querySelector && e.target.querySelector('#cc-contact')) initForm();
    initAll(e.target || d);
  });
})();
